import { isNumber } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { BaseViewportPlugin, getFramework, useIdentity, useScale } from '@/framework';
import { backgroundLayerPlugin } from '@/layers/background-layer';
import { IExportPlugin, ILayerProps, PluginType } from '@/version-types';
import CropBackgroundWrap from './components/crop-background-wrap';
import { CropBackground } from './crop-background';
import { CROP_BACKGROUND_EVENTS } from './event-name';

const CropBackgroundPlugin = React.memo(() => {
    const identity = useIdentity();
    const framework = getFramework(identity);
    const scale = useScale();
    const [backgroundData, setBackgroundData] = useState<ILayerProps | null>(null);
    const layerId = backgroundData?.id;
    const currentLayerId = useRef('');

    useEffect(() => {
        if (!layerId) return;
        currentLayerId.current = layerId;
        const handle = framework.events.onLayerChange(() => {
            // console.log('ot onLayerChange', { backgroundLayer: framework.getLayer(layerId) });
            setBackgroundData(framework.getLayer(layerId));
        }, layerId);
        return () => {
            framework.events.off(handle);
        };
    }, [layerId]);

    useEffect(() => {
        const openHandler = framework.events.on(CROP_BACKGROUND_EVENTS.CROP_OPEN, () => {
            // console.log('ot onCropOpen');
            setBackgroundData(framework.getBackgroundLayer(framework.stage.getActiveOriginIndex()));
        });
        const closeHandler = framework.events.on(CROP_BACKGROUND_EVENTS.CROP_CLOSE, () => {
            // console.log('ot onCropClose', currentLayerId.current);
            if (currentLayerId.current) {
                const originIndex = framework.tryGetLayerOriginIndex(currentLayerId.current);
                // console.log('ot onCropClose', { originIndex });
                if (isNumber(originIndex)) {
                    framework.stage.showMaterial(undefined, originIndex);
                }
            }
            setBackgroundData(null);
        });
        return () => {
            framework.events.off(openHandler);
            framework.events.off(closeHandler);
        };
    }, []);

    // console.log('ot backgroundData', { backgroundData, __isCropImage: backgroundData?.__isCropImage });

    if (!backgroundData || !backgroundData.__isCropImage) return null;

    return (
        <BaseViewportPlugin name="crop-background">
            <CropBackgroundWrap
                layer={backgroundData}
                scale={scale}
                stageWidth={backgroundData.width}
                stageHeight={backgroundData.height}
                framework={framework}
            />
        </BaseViewportPlugin>
    );
});

const exportPlugin: IExportPlugin = {
    type: PluginType.VIEWPORT,
    sort: 3,
    name: 'crop-background',
    createInstance({ identity }) {
        return [{ key: 'CropBackground', value: new CropBackground(identity) }];
    },
    render() {
        return <CropBackgroundPlugin />;
    },
    dependencies() {
        return [{ plugin: backgroundLayerPlugin }];
    },
};

export default exportPlugin;
